import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import httpHandler from "../utils/httpHandler";
import { VehicleModel } from "../models/VehicleModel";

export const getVehicleModels = createAsyncThunk<
  VehicleModel[],
  undefined,
  { rejectValue: string }
>("vehicle/vehicleModels", async (_, { rejectWithValue }) => {
  try {
    const response = await httpHandler.instanceAxios.get(
      "/api/vehicle/vehicleModels"
    );
    return response.data;
  } catch (e) {
    const error = e as AxiosError;
    return rejectWithValue(error.message);
  }
});


export interface VehicleModelState {
  vehicleModels: VehicleModel[],
  status: '' | 'pending' | 'fulfilled' | 'rejected';
}

export const initialState: VehicleModelState = {
  vehicleModels: [],
  status: '',
};

const vehicleModelSlice = createSlice({
  name: 'vehicleModel',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleModels.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(getVehicleModels.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.vehicleModels = action.payload;
      })
      .addCase(getVehicleModels.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export default vehicleModelSlice.reducer;

